<iframe
  #iframe
  [src]="matterportModelUrl"
  allowfullscreen
></iframe>
